module.exports = __webpack_public_path__ + "img/menuIcon12.1646b9bb.png";